import React from 'react'
import styled from 'styled-components'

import Button from '@helios/shared/components/button'
import {ContentWrapper, Details, DetailsSeparator} from '@helios/shared/styles/cards'
import {Text} from '@helios/shared/styles/typography'
import mq from '@helios/shared/utils/media-query'

import {tokens} from '../../theme'

export type EventCardProps = {
    title: string
    titleAs?: 'h2' | 'h3'
    category: string
    duration?: string
    location?: string
    language?: string
    date?: string
    time?: string
    description: string
    Image?: () => React.JSX.Element
    CTA?: (props: any) => React.JSX.Element
    withBorder?: boolean
}

export const EventCard = React.forwardRef<HTMLDivElement, EventCardProps>(
    (
        {
            title,
            titleAs = 'h3',
            category,
            duration,
            date,
            time,
            location,
            language,
            description,
            Image,
            CTA,
            ...rest
        },
        ref,
    ) => (
        <Card ref={ref} {...rest}>
            {!!Image && <Image />}
            <ContentWrapper>
                <Details as="p">
                    <Text as="span" variant="label-base" color="brand">
                        {category}
                    </Text>
                    {duration && (
                        <>
                            <DetailsSeparator as="span" />
                            <Text as="span" variant="label-base" color="lightMuted">
                                {duration}
                            </Text>
                        </>
                    )}
                    {language && (
                        <>
                            <DetailsSeparator as="span" />
                            <Text as="span" variant="label-base" color="lightMuted">
                                {language}
                            </Text>
                        </>
                    )}
                </Details>

                <div>
                    <Text as={titleAs}>{title}</Text>

                    <Details as="p">
                        {date && (
                            <Text as="span" variant="label-base" color="lightMuted">
                                {date}
                            </Text>
                        )}
                        {time && (
                            <>
                                <DetailsSeparator as="span" />
                                <Text as="span" variant="label-base" color="lightMuted">
                                    {time}
                                </Text>
                            </>
                        )}
                        {location && (
                            <>
                                <DetailsSeparator as="span" />
                                <Text as="span" variant="label-base" color="lightMuted">
                                    {location}
                                </Text>
                            </>
                        )}
                    </Details>
                </div>

                <Text variant="paragraph-base" color="lightMuted">
                    {description}
                </Text>
            </ContentWrapper>

            {!!CTA && <StyledButton variant="outline" forwardedAs={CTA} />}
        </Card>
    ),
)

const Card = styled.div`
    display: grid;
    gap: ${tokens.spacing20};
    grid-template-rows: max-content auto max-content;
    height: 100%;
`

const StyledButton = styled(Button)`
    width: 100%;

    ${mq.min('sm')} {
        width: max-content;
    }
`
